import request from '@/utils/request'

// 查询设备型号基本信息列表
export function listModel(query) {
  return request({
    url: '/device/model/list',
    method: 'get',
    params: query
  })
}

// 查询设备型号基本信息详细
export function getModel(modelId) {
  return request({
    url: '/device/model/' + modelId,
    method: 'get'
  })
}

// 新增设备型号基本信息
export function addModel(data) {
  return request({
    url: '/device/model',
    method: 'post',
    data: data
  })
}

// 修改设备型号基本信息
export function updateModel(data) {
  return request({
    url: '/device/model',
    method: 'put',
    data: data
  })
}

// 删除设备型号基本信息
export function delModel(modelId) {
  return request({
    url: '/device/model/' + modelId,
    method: 'delete'
  })
}

// 导出设备型号基本信息
export function exportModel(query) {
  return request({
    url: '/device/model/export',
    method: 'get',
    params: query
  })
}

/* 模型管理 */


/**
 * 获取模型列表
 */
export function getModelList(query) {
  return request({
    url: '/device/model/getModelList',
    method: 'get',
    params: query
  })
}


/**
 * 添加模型信息 
 * @param {object} data 模型信息 
 */
export function insertModel(data) {
  return request({
    url: '/device/model/insertModel',
    method: 'post',
    data: data
  })
}


/**
 * 修改模型信息 
 */
export function modifyModel(data) {
  return request({
    url: '/device/model/updateModel',
    method: 'put',
    data: data
  })
}


/**
 * 删除模型信息 
 * @param {string} id 模型主键ID不能为空 
 */
export function deleteModel(id) {
  if (id == null) {
    throw new Error('id is required')
  }
  return request({
    url: '/device/model/deleteModel',
    method: 'delete',
    data: {
      id
    }
  })
}



/**
 * 查询模型点表列表
 * @param {string} modelId 型号主键ID不能为空 
 */
export function getModelPointList(modelId) {
  return request({
    url: '/device/modelPoint/getModelPointList',
    method: 'get',
    params: {
      modelId: modelId
    }
  })
}


/**
 * 添加模型点表信息
 * @param {object} data 模型点表信息 
 */
export function insertModelPoint(data) {
  return request({
    url: '/device/modelPoint/insertModelPoint',
    method: 'post',
    data: data
  })
}


// 修改模型点表信息
export function updateModelPoint(data) {
  return request({
    url: '/device/modelPoint/updateModelPoint',
    method: 'put',
    data: data
  })
}


/**
 * 删除模型点表信息
 */
export function deleteModelPoint(data) {
  return request({
    url: '/device/modelPoint/deleteModelPoint',
    method: 'delete',
    data: data
  })
}


// 刷新缓存
export function refreshCache(id) {
  if (id == null) {
    throw new Error('ids is required')
  }
  return request({
    url: '/device/model/refreshCache',
    method: 'post',
    data: {
      id: id
    }
  })
}

export function listBatteryClusterModel(query) {
  return request({
    url: '/device/v3/battery/cluster/model/list',
    method: 'get',
    params: query
  })
}

export function addBatteryClusterModel(data) {
  return request({
    url: '/device/v3/battery/cluster/model',
    method: 'post',
    data
  })
}

export function updateBatteryClusterModel(data) {
  return request({
    url: '/device/v3/battery/cluster/model',
    method: 'put',
    data
  })
}

export function deleteBatteryClusterModel(id) {
  return request({
    url: `/device/v3/battery/cluster/model/${id}`,
    method: 'delete'
  })
}

export function getBatteryClusterModel(id) {
  return request({
    url: `/device/v3/battery/cluster/model/${id}`,
    method: 'get'
  })
}

export function listEBlockModel(query) {
  return request({
    url: '/device/v3/eblock/model/list',
    method: 'get',
    params: query
  })
}

export function addEBlockModel(data) {
  return request({
    url: '/device/v3/eblock/model',
    method: 'post',
    data
  })
}

export function updateEBlockModel(data) {
  return request({
    url: '/device/v3/eblock/model',
    method: 'put',
    data
  })
}

export function deleteEBlockModel(id) {
  return request({
    url: `/device/v3/eblock/model/${id}`,
    method: 'delete'
  })
}

export function getEBlockModel(id) {
  return request({
    url: `/device/v3/eblock/model/${id}`,
    method: 'get'
  })
}

export function listMeterModel(query) {
  return request({
    url: '/device/v3/meter/model/list',
    method: 'get',
    params: query
  })
}

export function addMeterModel(data) {
  return request({
    url: '/device/v3/meter/model',
    method: 'post',
    data
  })
}

export function updateMeterModel(data) {
  return request({
    url: '/device/v3/meter/model',
    method: 'put',
    data
  })
}

export function deleteMeterModel(id) {
  return request({
    url: `/device/v3/meter/model/${id}`,
    method: 'delete'
  })
}

export function getMeterModel(id) {
  return request({
    url: `/device/v3/meter/model/${id}`,
    method: 'get'
  })
}

export function listPhotovoltaicModel(query) {
  return request({
    url: '/device/v3/photovoltaic/model/list',
    method: 'get',
    params: query
  })
}

export function addPhotovoltaicModel(data) {
  return request({
    url: '/device/v3/photovoltaic/model',
    method: 'post',
    data
  })
}

export function updatePhotovoltaicModel(data) {
  return request({
    url: '/device/v3/photovoltaic/model',
    method: 'put',
    data
  })
}

export function deletePhotovoltaicModel(id) {
  return request({
    url: `/device/v3/photovoltaic/model/${id}`,
    method: 'delete'
  })
}

export function getPhotovoltaicModel(id) {
  return request({
    url: `/device/v3/photovoltaic/model/${id}`,
    method: 'get'
  })
}

export function listWaterMachineModel(query) {
  return request({
    url: '/device/v3/water/machine/model/list',
    method: 'get',
    params: query
  })
}

export function addWaterMachineModel(data) {
  return request({
    url: '/device/v3/water/machine/model',
    method: 'post',
    data
  })
}

export function updateWaterMachineModel(data) {
  return request({
    url: '/device/v3/water/machine/model',
    method: 'put',
    data
  })
}

export function deleteWaterMachineModel(id) {
  return request({
    url: `/device/v3/water/machine/model/${id}`,
    method: 'delete'
  })
}

export function getWaterMachineModel(id) {
  return request({
    url: `/device/v3/water/machine/model/${id}`,
    method: 'get'
  })
}

export function listChargePileModel(query) {
  return request({
    url: '/device/v3/charge/pile/model/list',
    method: 'get',
    params: query
  })
}

export function addChargePileModel(data) {
  return request({
    url: '/device/v3/charge/pile/model',
    method: 'post',
    data
  })
}

export function updateChargePileModel(data) {
  return request({
    url: '/device/v3/charge/pile/model',
    method: 'put',
    data
  })
}

export function deleteChargePileModel(id) {
  return request({
    url: `/device/v3/charge/pile/model/${id}`,
    method: 'delete'
  })
}

export function getChargePileModel(id) {
  return request({
    url: `/device/v3/charge/pile/model/${id}`,
    method: 'get'
  })
}

export function listPcsModel(query) {
  return request({
    url: '/device/v3/pcs/model/list',
    method: 'get',
    params: query
  })
}

export function addPcsModel(data) {
  return request({
    url: '/device/v3/pcs/model',
    method: 'post',
    data
  })
}

export function updatePcsModel(data) {
  return request({
    url: '/device/v3/pcs/model',
    method: 'put',
    data
  })
}

export function deletePcsModel(id) {
  return request({
    url: `/device/v3/pcs/model/${id}`,
    method: 'delete'
  })
}

export function getPcsModel(id) {
  return request({
    url: `/device/v3/pcs/model/${id}`,
    method: 'get'
  })
}
